import $ from 'jquery';

$(function () {
    const docSerachForm = $('.docs-search-form');

    $('.date', docSerachForm).datepicker({
        language: 'ru',
    });
});


// WEBPACK FOOTER //
// ./js/docs/index.js